import {
  APPLY_REWARD_ERROR_MESSAGES_CONTENT_TYPE,
  type ApplyRewardErrorMessages,
  useRewardErrorMessage as useSharedRewardErrorMessage,
} from '@sg/shared-fe-features-loyalty';

import { useContentfulContentTypeEntry } from '@order/Contentful';

/** Returns helpers that map apply and remove reward responses to error messages. */
export const useRewardErrorMessage = () => {
  const { data } = useContentfulContentTypeEntry<ApplyRewardErrorMessages>({
    contentType: APPLY_REWARD_ERROR_MESSAGES_CONTENT_TYPE,
  });

  return useSharedRewardErrorMessage({ messages: data?.fields });
};
